<template>
    <div>
        <MainContentTabs
            title="Listado de comunicados"
            :tabs="[
                { tab : 'email', nombre: 'Email' },
                { tab : 'whatsapp', nombre: 'WhatsApp' }
            ]"
            :initialTab="tab"
            @selectTab="(newTab) => { tab = newTab }"
        >
            <template #email>
                <TablaComunicados :tab="tab" @setLoading="(estado) => { loading = estado }">
                    <template #extra-buttons>
                        <router-link :to="{ name: 'back.comunicados.recordatorios.index' }" class="btn btn-primary mr-0 mr-md-2 mt-2 mt-md-0 mb-2 mb-md-0" :class="{ 'disabled': loading }">
                            EMAILS RECORDATORIOS
                        </router-link>
                        <router-link :to="{ name: 'back.comunicados.emails.index' }" class="btn btn-primary mr-2 mb-2 mb-md-0" :class="{ 'disabled': loading }">
                            EMAILS ALTERNATIVOS
                        </router-link>
                        <router-link :to="{ name: 'back.comunicados.bases.index' }" class="btn btn-primary mb-2 mb-md-0" :class="{ 'disabled': loading }">
                            BASES DE EMAILS
                        </router-link>
                    </template>
                </TablaComunicados>
            </template>
            <template #whatsapp>
                <TablaComunicados :tab="tab" @setLoading="(estado) => { loading = estado }" />
            </template>
        </MainContentTabs>
    </div>
</template>

<script>
    import MainContentTabs from '@/components/backend/components/MainContentTabs';
    import TablaComunicados from '@/components/backend/comunicados/TablaComunicados';

    export default {
        data() {
            return {
                tab: this.$route.query.tipo ? (parseInt(this.$route.query.tipo) === 1 ? 'email' : 'whatsapp') : 'email',
                loading: false
            }
        },
        created() {
            if (!this.$route.query.tipo) {
                this.replaceQueryUrl(1);
            }
        },
        watch: {
            tab(newTab) {
                const tipo = newTab === 'email' ? 1 : 2;
                this.replaceQueryUrl(tipo);
            }
        },
        methods: {
            replaceQueryUrl(tipo) {
                this.$router.replace({ 
                    query: { ...this.$route.query, tipo: tipo } 
                });
            }
        },
        components: {
            MainContentTabs, TablaComunicados
        }
    }
</script>
